import { Table, TableBody, TableCell, TableHead, TableRow, Hidden } from "@mui/material";
import { useTranslation } from "react-i18next";

function DataTable({ data }) {
  const { t } = useTranslation();

  if (!Array.isArray(data.peers) || data.peers.length === 0) {
    return <p>{t("No data available.")}</p>;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <Hidden smDown>
            <TableCell>{t("Name")}</TableCell>
          </Hidden>
          <TableCell>{t("HTTP Address")}</TableCell>
          <TableCell>{t("Recon Address")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data["peers"].map((row) => (
          <TableRow key={row.Name}>
            <Hidden smDown><TableCell>{row.Name}</TableCell></Hidden>
            <TableCell><a href={`http://${row.httpAddr}/pks/lookup?op=stats`} aria-label={`Visit ${row.name} peer`}>{row.httpAddr}</a></TableCell>
            <TableCell>{row.reconAddr}</TableCell>
            {/* Add more table cells for other fields */}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default DataTable;
